import { Component, PLATFORM_ID, OnInit, inject } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { Observable, Subscription } from 'rxjs';
import { User } from '../../../user/models/user.model';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '../../../../core/services/auth.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { MatDividerModule } from '@angular/material/divider';
import { HapticsService } from '../../../general/services/haptics.service';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  animations: [
    trigger('avatarFade', [
      state('in', style({ opacity: 1, transform: 'scale(1)' })),
      state('out', style({ opacity: 0, transform: 'scale(0.8)' })),
      transition('out => in', [animate('200ms ease-in')]),
      transition('in => out', [animate('200ms ease-out')])
    ])
  ]
})
export class Header implements OnInit {
  dialog = inject(MatDialog);
  private platformId = inject(PLATFORM_ID);
  bottomSheet = inject(MatBottomSheet);
  private router = inject(Router);
  private haptics = inject(HapticsService);
  private authService = inject(AuthService);

  isSignedIn = false; 
  user: User | null = null;
  private userSubscription: Subscription | undefined;
  user$: Observable<User | null>;

  constructor() {
    this.user$ = this.authService.user$;
    // this.isSignedIn = this.authService.isAuthenticated();
  }

  ngOnInit(): void {
    this.userSubscription = this.authService.user$.subscribe((user) => {
      if (user) {
        this.isSignedIn = true;
        this.user = user;
      } else {
        this.isSignedIn = false;
        this.user = null;
      }
    });
  }

  goToAdmin = () => {
    this.haptics.click();
    this.router.navigate(['/profile/admin']);
  }

  goToSalesDashboard = () => {
    this.haptics.click();
    this.router.navigate(['/sales/dashboard']);
  }

  goHome = () => {
    this.haptics.click();
    this.router.navigate(['']);
  }

  openLogin = () => {
    this.haptics.click();
    this.router.navigate(['/login']);
  }

  logout = () => {
    this.haptics.click();
    this.authService.logout();
  }

  goToProfile = () => {
    this.haptics.click();
    console.log('goToProfile');
    this.router.navigate(['/profile']);
  }

  goToManageProperties = () => {
    this.haptics.click();
    console.log('goToManageProperties');
    this.router.navigate(['/profile/manage-properties']);
  }

  closeSidenav(sidenav: MatSidenav): void {
    this.haptics.click();
    sidenav.close();
  }

  // Compute user initials from username
  get userInitials(): string {
    if (!this.user || !this.user || !this.user.lastName) return '??';
    // const names = this.user.username.trim().split(/\s+/);
    // if (names.length === 1) {
    //   return names[0].charAt(0).toUpperCase();
    // }
    return (this.user?.firstName?.charAt(0) + (this.user?.lastName ? this.user.lastName.charAt(0) : '')).toUpperCase();
  }

  // Generate dynamic background color based on username
  get avatarColor(): string {
    if (!this.user || !this.user.username) return '#4a90e2'; // Default color
    let hash = 0;
    for (let i = 0; i < this.user.username.length; i++) {
      hash = this.user.username.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash % 360);
    //return `hsl(${hue}, 50%, 60%)`; // Dynamic HSL color
    return 'oklab(60% -0.3 -0.1)';
  }

  openLikes() {
    this.haptics.click();
    this.router.navigate(['/profile/saved']);
    // this.bottomSheet.open(LikeListComponent, {
    //   panelClass: 'user-likes-bottom-sheet',
    //   disableClose: false,
    //   // hasBackdrop: true,
    //   // backdropClass: 'bottom-sheet-backdrop',
    //   // disableClose: false,
    //   closeOnNavigation: true
    // });
  }
}
